import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const MainContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
  flex: 1;
  overflow-y: auto;
  margin-top: 0;
  transition: all 0.3s ease;
`;

export const SkillsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 24px;
  width: 100%;
  align-items: start;
`;

export const SkillCard = styled.div`
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s;
  align-self: start;

  &:hover {
    background-color: #f1f3f5;
    border-color: #bdbdbd;
  }
`;

export const SkillCardContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SkillTitle = styled.div`
  margin: 0;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
`;

export const SkillCategory = styled.div`
  font-size: 13px;
  color: #666;
  background-color: #e9ecef;
  border-radius: 20px;
  padding: 2px 10px;
  display: inline-block;
  margin-bottom: 12px;
`;

export const SkillAliases = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  line-height: 1.4;
`;

export const ItalicText = styled.span`
  color: #94A3B8;
  font-style: italic;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: auto;
  padding-top: 12px;
`;

export const EmployeeBadge = styled.div`
  font-size: 12px;
  color: #64748b;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  svg {
    color: #94a3b8;
    font-size: 14px;
  }
`;

export const UsageBadgesContainer = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex-shrink: 0;
`;

export const UsageBadge = styled.div`
  font-size: 11px;
  color: #475569;
  background-color: #f1f5f9;
  padding: 2px 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #e2e8f0;
  white-space: nowrap;

  svg {
    font-size: 14px;
    color: #64748b;
  }
`;

export const CreatedAtText = styled.div`
  font-size: 11px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 4px;

  svg {
    font-size: 12px;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
  border-bottom: 1px solid #e5e7eb;
`;

export const TabButton = styled.button`
  padding: 8px 16px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  position: relative;
  color: ${props => props.active ? COLORS.PRIMARY : '#6b7280'};
  
  &:after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background-color: ${props => props.active ? COLORS.PRIMARY : 'transparent'};
  }
  
  &:hover {
    color: ${COLORS.PRIMARY};
  }
`; 